import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.32134 16.6787C4.24173 15.7453 2 12.8844 2 9.5 2 5.35786 5.35786 2 9.5 2c3.3844 0 6.2453 2.24173 7.1787 5.32134C19.7583 8.25475 22 11.1156 22 14.5c0 4.1421-3.3579 7.5-7.5 7.5-3.3844 0-6.24525-2.2417-7.17866-5.3213zm9.67806-7.07932c-.6154-.31445-1.2977-.51641-2.02-.57878C14.8214 9.00696 14.6615 9 14.5 9c-2.5133 0-4.63279 1.6857-5.28961 3.9882-.702-.0575-1.34533-.3222-1.86875-.7327.94459-3.01562 3.74216-5.21178 7.05896-5.25485C13.4904 5.21946 11.6376 4 9.5 4 6.46243 4 4 6.46243 4 9.5c0 2.1376 1.21946 3.9904 3.00064 4.9006.03804.0195.07634.0385.11488.057.58496.2819 1.22745.4633 1.90508.5218.15799.0136.31788.0206.4794.0206 2.5133 0 4.6328-1.6857 5.2896-3.9882.702.0575 1.3453.3222 1.8688.7327-.9446 3.0156-3.7422 5.2118-7.05902 5.2549C10.5096 18.7805 12.3624 20 14.5 20c3.0376 0 5.5-2.4624 5.5-5.5 0-2.1376-1.2195-3.9904-3.0006-4.90062z",
    fill: "currentColor"
  }));
});